import { gql } from "lib/apolloClient";

export const reorderLearningCourseUnitPlanMutation = gql`
  mutation reorderLearningCourseUnitPlan($input: UnitPlanReorderInput!) {
    planner {
      reorderLearningCourseUnitPlan(input: $input)
    }
  }
`;

export const updateLockedStateMutation = gql`
  mutation updateLockedState($input: LearningCourseEntityLockUpdateInput!) {
    planner {
      bulkUpdateLearningCourseEntityLock(input: $input) {
        isSuccess
      }
    }
  }
`;
